import type { RetailChain } from './retailEngine'
import type { NearbyStore } from './storeTypes'
import { supabase } from './supabaseClient'

export async function fetchRetailChains(countryCode: string): Promise<RetailChain[]> {
  const { data, error } = await supabase
    .from('retail_chains')
    .select('id, name, brand_key, country_code, is_active')
    .eq('country_code', countryCode.toUpperCase())
    .eq('is_active', true)
    .order('name')

  if (error) {
    console.error('fetchRetailChains error:', error.message)
    return []
  }

  return (data ?? []) as RetailChain[]
}

export function registryStoresFromChains(chains: RetailChain[]): NearbyStore[] {
  return chains.map((chain) => ({
    name: chain.name,
    chain: chain.brand_key.toUpperCase(),
    brand_key: chain.brand_key,
    retail_chain_id: chain.id,
    address: 'Regional network',
    distance_km: 0,
    is_registry_fallback: true,
  }))
}
